import React from 'react';
import { GridLayoutProps, GridLayoutWithSortProps } from './types';
import Layout from './Layout';
import { OrderedListWrapper } from '../OrderedList';


export function GridLayout(
  props: GridLayoutProps,
) {
  return (
    <Layout {...props} />
  );
}

export function GridLayoutWithSort<T = { id: number, [key: string]: any }>(
  props: GridLayoutWithSortProps<T>,
) {
  return (
    <OrderedListWrapper<T>
      orderingConfig={props.orderingConfiguration}
    >
      <GridLayout {...props}>
        {props.children}
      </GridLayout>
    </OrderedListWrapper>
  );
}
